module.exports = __webpack_public_path__ + "static/media/visuel07.5e2cad73.jpg";